import { useEffect, useState } from "react";

// UI-DESIGN: phones spend much of a game asleep. Pause polling when hidden,
// and catch up on return without depending on global Redux listeners.
export function useVisiblePolling() {
  const [visible, setVisible] = useState(() => document.visibilityState === "visible");
  useEffect(() => {
    const update = () => setVisible(document.visibilityState === "visible");
    document.addEventListener("visibilitychange", update);
    return () => document.removeEventListener("visibilitychange", update);
  }, []);
  return visible ? 10_000 : 0;
}

export function useRefreshOnReturn(refetch: () => unknown, enabled = true) {
  useEffect(() => {
    if (!enabled) return;
    const refresh = () => {
      if (document.visibilityState === "visible") void refetch();
    };
    window.addEventListener("focus", refresh);
    window.addEventListener("online", refresh);
    document.addEventListener("visibilitychange", refresh);
    return () => {
      window.removeEventListener("focus", refresh);
      window.removeEventListener("online", refresh);
      document.removeEventListener("visibilitychange", refresh);
    };
  }, [refetch, enabled]);
}
